import React from 'react'
import Header from './components/Header'
import Meme from './components/Meme'
// import Counter from './components/Counter'




export default function App(){

    return(
        <>
        <Header/>
        <Meme/>
        {/* <Counter/> */}
        </>
    )
}

